<template>
  <div class="wrapper">
   <Card class="m-b steps">
      <!--  <Steps :current="currentStep - 1">
        <Step title="店铺信息"
              content="填写基本店铺信息"></Step>
        <Step title="负责人信息"
              content="填写负责人信息"></Step>
        <Step title="财务信息"
              content="填写财务信息"></Step>
      </Steps>-->
      <h3 style="text-align: center;">{{$t('pages_lcsw_accounts_index_505')}}</h3>
    </Card>
    <!-- <Card class="m-b"> -->
      <Modal v-model="modalShow"
             @on-ok="handleSubmit"
             :title="$t('pages_lcsw_accounts_index_506')">
        <Table style="margin-top: 20px;"
               border
               :loading="sLoading"
               :columns="columns"
               :data="shops"></Table>
      </Modal>
      <!-- <i-form>
        <Form-item label="快速通道">
          <el-button size="medium"
                     class="filter-item"
                     type="primary"
                     @click.prevent="searchBtnClick()">选择已通过的商户的资质</el-button>
        </Form-item>
      </i-form> -->
    <!-- </Card> -->
    <Card class="form">
      <Form ref="lcsw_account"
            :rules="rules"
            :key="fromKey"
            :model="lcsw_account"
            :label-width="280">
        <Form-item :label="$t('pages_balance_transaction_index_176')"
                   prop="status"
                   v-if="lcsw_account.status">
          <!-- <Input disabled type="text" v-model="lcsw_account.status" /> -->
          <span style="color: green">{{ lcsw_account.status }}</span>
        </Form-item>
        <div v-if="lcsw_account.status !== $t('pages_lcsw_accounts_index_507')">
          <!-- <template v-if="currentStep === 1"> -->
            <Form-item :label="$t('pages_lcsw_accounts_index_508')"
                       prop="merchant_business_type">
              <Select label-in-value
                      :value="lcsw_account.merchant_business_type"
                      @on-change="change_merchant_business_type">
                <Option v-for="item in merchant_business_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_509')"
                       prop="account_type">
              <Select label-in-value
                      v-model="lcsw_account.account_type">
                <Option v-for="item in account_types"
                        :value="item.code"
                        :disabled="lcsw_account.merchant_business_type === '3' && item.code === '1'"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_510')"
                       prop="settlement_type">
              <Select label-in-value
                      v-model="lcsw_account.settlement_type">
                <Option v-for="item in settlement_types"
                        :value="item.code"
                        :disabled="lcsw_account.merchant_business_type === '3' ? item.code === '2' : (lcsw_account.account_type === '1' && item.code === '2')"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Divider>{{$t('pages_lcsw_accounts_index_511')}}</Divider>
            <Form-item :label="$t('pages_lcsw_accounts_index_512')"
                       prop="merchant_name">
              <Input type="text"
                     v-model="lcsw_account.merchant_name" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_513')"
                       :show-message="false"
                       prop="merchant_alias">
              <Input type="text"
                     v-model="lcsw_account.merchant_alias" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_514')"
                       prop="merchant_company">
              <Input type="text"
                     v-model="lcsw_account.merchant_company" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_515')"
                       prop="merchant_province_code">
              <Select label-in-value
                      :value="lcsw_account.merchant_province_code"
                      @on-change="change_province">
                <Option v-for="item in provinces"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_516')"
                       prop="merchant_city_code">
              <Select label-in-value
                      :value="lcsw_account.merchant_city_code"
                      @on-change="change_city">
                <Option v-for="item in cities"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_517')"
                       prop="merchant_county_code">
              <Select label-in-value
                      :value="lcsw_account.merchant_county_code"
                      @on-change="change_county">
                <Option v-for="item in counties"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_518')"
                       :show-message="false"
                       prop="merchant_address">
              <Input type="text"
                     v-model="lcsw_account.merchant_address" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_519')"
                       :show-message="false"
                       prop="merchant_person">
              <Input type="text"
                     v-model="lcsw_account.merchant_person" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_520')"
                       :show-message="false"
                       prop="merchant_phone">
              <Input type="text"
                     v-model="lcsw_account.merchant_phone" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_521')"
                       :show-message="false"
                       prop="merchant_email">
              <Input type="text"
                     v-model="lcsw_account.merchant_email" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_522')"
                       prop="business_code">
              <Select label-in-value
                      :value="lcsw_account.business_code"
                      @on-change="change_business_code">
                <Option v-for="item in industries"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_523')"
                       :show-message="false"
                       prop="img_logo">
              <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_logo')}"
                        :limit="5"
                        :url="lcsw_account.img_logo"></uploader>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_524')"
                       :show-message="false"
                       prop="img_indoor">
              <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_indoor')}"
                        :limit="5"
                        :url="lcsw_account.img_indoor"></uploader>
            </Form-item>
            <Divider>{{$t('pages_lcsw_accounts_index_525')}}</Divider>
            <Form-item v-if="lcsw_account.merchant_business_type !== '3'"
                       :label="$t('pages_lcsw_accounts_index_526')"
                       :show-message="false"
                       prop="license_no">
              <Input type="text"
                     v-model="lcsw_account.license_no" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_527')"
                       :show-message="false"
                       prop="license_type">
              <Select label-in-value
                      :value="lcsw_account.license_type"
                      @on-change="change_license_type">
                <Option v-for="item in license_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item v-if="lcsw_account.merchant_business_type !== '3'"
                       :label="$t('pages_lcsw_accounts_index_528')"
                       :show-message="false"
                       prop="img_license">
              <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_license')}"
                        :limit="5"
                        :url="lcsw_account.img_license"></uploader>
            </Form-item>
            <template v-if="lcsw_account.merchant_business_type === '1' || lcsw_account.merchant_business_type === '2' && lcsw_account.account_type === '1'">
              <Form-item :label="$t('pages_lcsw_accounts_index_529')"
                        :show-message="false"
                        prop="img_open_permits">
                <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_open_permits')}"
                          :limit="5"
                          :url="lcsw_account.img_open_permits"></uploader>
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_530')"
                        :show-message="false"
                        prop="img_org_code">
                <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_org_code')}"
                          :limit="5"
                          :url="lcsw_account.img_org_code"></uploader>
              </Form-item>
            </template>
            <Form-item v-if="lcsw_account.merchant_business_type === '3'"
                       :label="$t('pages_lcsw_accounts_index_531')"
                       prop="img_idcard_holding">
              <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_idcard_holding')}"
                        :limit="5"
                        :url="lcsw_account.img_idcard_holding"></uploader>
            </Form-item>
            <template v-if="lcsw_account.account_type === '1' ? true : lcsw_account.settlement_type === '2'">
              <Form-item :label="$t('pages_lcsw_accounts_index_532')"
                        :show-message="false"
                        prop="artif_nm">
                <Input type="text"
                      v-model="lcsw_account.artif_nm" />
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_533')"
                        prop="lcsw_account.legalIdnum">
                <Input type="text"
                      v-model="lcsw_account.legalIdnum" />
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_584')"
                        :show-message="false"
                        prop="legalIdnumExpire">
                <el-date-picker
                  style="width: 100%;"
                  type="date"
                  v-model="lcsw_account.legalIdnumExpire"
                  :placeholder="$t('components_tabs_time_picker_tabs_time_picker_35')"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_534')"
                        :show-message="false"
                        prop="img_idcard_a">
                <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_idcard_a')}"
                          :limit="5"
                          :url="lcsw_account.img_idcard_a"></uploader>
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_535')"
                        :show-message="false"
                        prop="img_idcard_b">
                <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_idcard_b')}"
                          :limit="5"
                          :url="lcsw_account.img_idcard_b"></uploader>
              </Form-item>
            </template>
            <Divider>{{$t('pages_lcsw_accounts_index_536')}}</Divider>
            <template>
              <Form-item :label="$t('pages_lcsw_accounts_index_537')"
                        :show-message="false"
                        prop="company_account_name"
                        :class="lcsw_account.merchant_business_type === '1' && lcsw_account.account_type === '2' ? 'requiredFormItem' : 'rrr'">
                <Input type="text"
                      v-model="lcsw_account.company_account_name" />
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_538')"
                        :show-message="false"
                        prop="company_account_no">
                <Input type="text"
                      v-model="lcsw_account.company_account_no" />
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_539')"
                        :show-message="false"
                        prop="company_bank_no">
                <span>{{lcsw_account.company_bank_name}}</span>
                <Select label-in-value
                        @on-change="change_company_bank"
                        filterable
                        remote
                        :remote-method="net_banks_index"
                        :value="lcsw_account.company_bank_no"
                        :placeholder="$t('pages_lcsw_accounts_index_540')">
                  <Option v-for="item in net_banks"
                          :value="item.code"
                          :key="item.code">{{ item.text }}</Option>
                </Select>
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_541')"
                        :show-message="false"
                        prop="company_bank_no">
                <Input type="text"
                      v-model="lcsw_account.company_bank_no" />
              </Form-item>
            </template>
            <!-- <Form-item label="结算费率"
                       :show-message="false"
                       prop="rate_code">
              <Input type="text"
                     v-model="lcsw_account.rate_code" />
            </Form-item> -->
            <!-- <Form-item label="结算方式">
              <Input type="text"
                     readonly
                     value="结算到银行卡" />
            </Form-item> -->
            <Form-item :label="$t('pages_lcsw_accounts_index_542')"
                       :show-message="false"
                       prop="account_name">
              <Input type="text"
                     v-model="lcsw_account.account_name" />
            </Form-item>
            <Form-item v-if="lcsw_account.account_type === '2'"
                       :label="$t('pages_lcsw_accounts_index_543')"
                       :show-message="false"
                       prop="merchant_id_no">
              <Input type="text"
                     v-model="lcsw_account.merchant_id_no" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_544')"
                       :show-message="false"
                       prop="account_no">
              <Input type="text"
                     v-model="lcsw_account.account_no" />
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_545')"
                       prop="bank_no">
              <span>{{lcsw_account.bank_name}}</span>
              <Select label-in-value
                      @on-change="change_bank"
                      filterable
                      remote
                      :remote-method="net_banks_index"
                      :value="lcsw_account.bank_no"
                      :placeholder="$t('pages_lcsw_accounts_index_540')">
                <Option v-for="item in net_banks"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <template v-if="lcsw_account.account_type === '2'">
              <Form-item :label="$t('pages_lcsw_accounts_index_546')"
                        :show-message="false"
                        prop="img_bankcard_a">
                <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_bankcard_a')}"
                          :limit="5"
                          :url="lcsw_account.img_bankcard_a"></uploader>
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_547')"
                        :show-message="false"
                        prop="img_private_idcard_a">
                <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_private_idcard_a')}"
                          :limit="5"
                          :url="lcsw_account.img_private_idcard_a"></uploader>
              </Form-item>
              <Form-item :label="$t('pages_lcsw_accounts_index_548')"
                        :show-message="false"
                        prop="img_private_idcard_b">
                <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_private_idcard_b')}"
                          :limit="5"
                          :url="lcsw_account.img_private_idcard_b"></uploader>
              </Form-item>
            </template>
            <Form-item v-if="lcsw_account.account_type === '2' && lcsw_account.settlement_type === '2'"
                       :label="$t('pages_lcsw_accounts_index_549')"
                       :show-message="false"
                       prop="img_unincorporated">
              <uploader @uploadedUrl="(url)=>{this.uploadedUrl_img(url, 'img_unincorporated')}"
                        :limit="5"
                        :url="lcsw_account.img_unincorporated"></uploader>
            </Form-item>
          <!-- </template> -->

          <!-- <template v-if="currentStep === 2"> -->
            <!-- <Form-item label="联系人"
                       prop="account_name">
              <Input type="text"
                     v-model="lcsw_account.account_name" />
            </Form-item> -->
          <!-- </template> -->

          <!-- <template v-if="currentStep === 3"> -->
            <Form-item :label="$t('pages_lcsw_accounts_index_550')"
                       :show-message="false"
                       prop="settle_type">
              <Select label-in-value
                      v-model="lcsw_account.settle_type">
                <Option v-for="item in settle_types"
                        :value="item.code"
                        :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
            <Form-item :label="$t('pages_lcsw_accounts_index_551')"
                       :show-message="false"
                       prop="settle_amount">
              <Input type="text"
                     v-model="lcsw_account.settle_amount"
                     :placeholder="$t('pages_lcsw_accounts_index_552')" />
            </Form-item>
          <!-- </template> -->

          <Form-item>
            <!-- <Button class="m-r"
                    type="default"
                    v-if="currentStep > 1"
                    html-type="button"
                    @click="prevStep">上一页</Button>
            <Button class="m-r"
                    type="default"
                    v-if="currentStep < 3"
                    html-type="button"
                    @click="nextStep">下一页</Button> -->
            <!-- v-if="currentStep === 3" -->
            <Button type="primary"
                    html-type="button"
                    :loading="loading"
                    @click="handleSubmit">{{$t('pages_bookings_new_235')}}</Button>
          </Form-item>
        </div>
      </Form>
    </Card>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import Uploader from '@/components/uploader-aliyun/single'
import { commonButtonInTable } from '@/libs/table-render'

const LS_KEY_LCSW_ACCOUNT = 'LS_KEY_LCSW_ACCOUNT';

export default {
  components: {
    Uploader
  },
  data () {
    return {
      fromKey: new Date().getTime(),
      currentStep: 1,
      modalShow: false,
      columns: [
        {
          title: i18n.t('pages_lcsw_accounts_index_553'),
          key: 'name'
        },
        {
          title: i18n.t('pages_lcsw_accounts_index_554'),
          width: 120,
          align: 'center',
          key: 'lcsw_account_status'
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 100,
          render: (h, params) => {
            const children = []
            if (params.row.lcsw_account_status === i18n.t('pages_lcsw_accounts_index_507')) {
              children.push(
                commonButtonInTable(
                  this,
                  h,
                  'warning',
                  i18n.t('pages_lcsw_accounts_index_555'),
                  this.shop_select,
                  [params.row.id]
                )
              )
            }
            return h('div', children)
          }
        }
      ],
      merchant_business_types: [
        { text: i18n.t('pages_lcsw_accounts_index_556'), code: '3' },
        { text: i18n.t('pages_lcsw_accounts_index_557'), code: '2' },
        { text: i18n.t('pages_lcsw_accounts_index_558'), code: '1' }
      ],
      settle_types: [
        { text: i18n.t('pages_lcsw_accounts_index_559'), code: '2' },
        { text: i18n.t('pages_lcsw_accounts_index_560'), code: '1' }
      ],
      settlement_types: [
        { text: i18n.t('pages_lcsw_accounts_index_561'), code: '1' },
        { text: i18n.t('pages_lcsw_accounts_index_562'), code: '2' }
      ],
      account_types: [
        { text: i18n.t('pages_lcsw_accounts_index_563'), code: '2' },
        { text: i18n.t('pages_lcsw_accounts_index_564'), code: '1' }
      ],
      license_types: [
        { text: i18n.t('pages_lcsw_accounts_index_565'), code: '2' },
        { text: i18n.t('pages_lcsw_accounts_index_566'), code: '1' },
        { text: i18n.t('pages_lcsw_accounts_index_567'), code: '0' }
      ]
    }
  },
  async created () {
    await this.province_index()
    await this.find_one().then(data => {
      // console.info('data', data.data)
      const { merchant_province_code } = data.data
      this.change_province({
        value: merchant_province_code
      }, true)
    })
    this.industries_index()
    this.handleLocalData()
  },
  computed: {
    ...mapGetters('lcsw_account', [
      'lcsw_account',
      'loading',
      'provinces',
      'cities',
      'counties',
      'net_banks',
      'industries'
    ]),
    ...mapGetters('shop', { shops: 'shops', meta: 'meta', sLoading: 'loading' }),
    rules () {
      const MICRO_CO = '3'; // 小微企业
      const SINGLE = '2'; // 个体户
      const COMPANY = '1'; // 公司
      const requiredFields = [
        { key: 'merchant_name', title: i18n.t('pages_lcsw_accounts_index_512'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_alias', title: i18n.t('pages_lcsw_accounts_index_513'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_company', title: i18n.t('pages_lcsw_accounts_index_568'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'license_type', title: i18n.t('pages_lcsw_accounts_index_527'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'business_code', title: i18n.t('pages_lcsw_accounts_index_569'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_province_code', title: i18n.t('pages_lcsw_accounts_index_515'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_city_code', title: i18n.t('pages_lcsw_accounts_index_516'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_county_code', title: i18n.t('pages_lcsw_accounts_index_517'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_address', title: i18n.t('pages_lcsw_accounts_index_570'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_business_type', title: i18n.t('pages_lcsw_accounts_index_508'), step: 1 },
        { key: 'img_license', title: i18n.t('pages_lcsw_accounts_index_528'), step: 1, business_type: [COMPANY, SINGLE] },
        { key: 'img_org_code', title: i18n.t('pages_lcsw_accounts_index_571'), step: 1, business_type: [COMPANY] },
        { key: 'img_logo', title: i18n.t('pages_lcsw_accounts_index_572'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_indoor', title: i18n.t('pages_lcsw_accounts_index_572'), step: 1, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'license_no', title: i18n.t('pages_lcsw_accounts_index_526'), step: 1, business_type: [COMPANY] },
        { key: 'account_name', title: i18n.t('pages_lcsw_accounts_index_573'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_person', title: i18n.t('pages_lcsw_accounts_index_574'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'artif_nm', title: i18n.t('pages_lcsw_accounts_index_532'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'legalIdnum', title: i18n.t('pages_lcsw_accounts_index_533'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_idcard_a', title: i18n.t('pages_lcsw_accounts_index_534'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_idcard_b', title: i18n.t('pages_lcsw_accounts_index_535'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_phone', title: i18n.t('pages_lcsw_accounts_index_575'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_idcard_holding', title: i18n.t('pages_lcsw_accounts_index_576'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_email', title: i18n.t('pages_lcsw_accounts_index_577'), step: 2, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'account_no', title: i18n.t('pages_lcsw_accounts_index_578'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'account_type', title: i18n.t('pages_lcsw_accounts_index_509'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_bankcard_a', title: i18n.t('pages_lcsw_accounts_index_546'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'settle_type', title: i18n.t('pages_lcsw_accounts_index_550'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'settle_amount', title: i18n.t('pages_lcsw_accounts_index_551'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'settlement_type', title: i18n.t('pages_lcsw_accounts_index_510'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'merchant_id_no', title: i18n.t('pages_lcsw_accounts_index_579'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_open_permits', title: i18n.t('pages_lcsw_accounts_index_529'), step: 3, business_type: [COMPANY] },
        { key: 'img_private_idcard_a', title: i18n.t('pages_lcsw_accounts_index_547'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_private_idcard_b', title: i18n.t('pages_lcsw_accounts_index_548'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'img_unincorporated', title: i18n.t('pages_lcsw_accounts_index_549'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'bank_no', title: i18n.t('pages_lcsw_accounts_index_580'), step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
        { key: 'company_account_name', title: i18n.t('pages_lcsw_accounts_index_537'), step: 3, business_type: [COMPANY] },
        { key: 'company_account_no', title: i18n.t('pages_lcsw_accounts_index_538'), step: 3, business_type: [COMPANY] },
        { key: 'company_bank_name', title: i18n.t('pages_lcsw_accounts_index_539'), step: 3, business_type: [COMPANY] },
        { key: 'company_bank_no', title: i18n.t('pages_lcsw_accounts_index_541'), step: 3, business_type: [COMPANY] },
        // { key: 'rate_code', title: '结算费率', step: 3, business_type: [COMPANY, MICRO_CO, SINGLE] },
      ];
      const rules = {};
      requiredFields.filter(i => {
        if (!i.business_type) return true;
        // console.log('this.lcsw_account.merchant_business_type', this.lcsw_account.merchant_business_type, i.business_type);
        return i.business_type.includes(this.lcsw_account.merchant_business_type);
      }).forEach((i) => {
        rules[i.key] = [{
          // required: i.step === this.currentStep,
          required: true,
          validator: (rule, value, callback) => {
            // if (i.step !== this.currentStep) {
            //   callback()
            // } else
            if (!this.lcsw_account[i.key]) {
              callback(new Error(i.title + i18n.t('pages_lcsw_accounts_index_581')))
            } else {
              callback()
            }
          },
        }]
      });
      // this.currentStep === 3 &&
      if (this.lcsw_account.settle_type === '1') {
        rules.settle_amount = [{ required: true, message: i18n.t('pages_lcsw_accounts_index_582') }]
      }
      // if (this.currentStep === 1) {
      rules.merchant_business_type = [{ required: true, message: i18n.t('pages_lcsw_accounts_index_583') }];
      // }
      console.log('rules:', rules);
      return rules;
    }
  },
  methods: {
    ...mapActions('lcsw_account', [
      'counties_index',
      'find_one',
      'grant',
      'province_index',
      'cities_index',
      'net_banks_index',
      'industries_index',
      'create',
      'destroy',
      'update',
      'set_record'
    ]),
    ...mapActions('shop', [
      'clear',
      'index'
    ]),
    ...mapMutations('lcsw_account', {
      setLoading: 'loading'
    }),
    setLocalData () {
      const local = this.getLocal();
      this.set_record(local);
      if (local) {
        if (local.merchant_province_code) {
          this.cities_index(local.merchant_province_code)
        }
        if (local.merchant_city_code) {
          this.counties_index(local.merchant_city_code)
        }
      }
    },
    handleLocalData () {
      this.$nextTick(() => {
        if (!this.lcsw_account.id) {
          this.setLocalData();
        } else {
          this.clearLocal();
        }
      })
    },
    searchBtnClick () {
      this.index()
      this.modalShow = true
    },
    shop_select (shop_id) {
      this.grant({ shop_id })
      this.modalShow = false
    },
    async change_province (e, init) {
      e = e || {};
      console.info('change_province', e.value, this.lcsw_account.merchant_province_code)
      if (e.value !== this.lcsw_account.merchant_province_code || init) {
        this.lcsw_account.merchant_province = e.label
        this.lcsw_account.merchant_province_code = e.value
        e.value && this.cities_index(e.value)
        if (init) {
          const { merchant_city_code } = this.lcsw_account
          this.change_city({
            value: merchant_city_code
          }, true)
        } else {
          this.lcsw_account.merchant_city = '';
          this.lcsw_account.merchant_city_code = '';
        }
      }
    },
    change_city (e, init) {
      e = e || {};
      if (e.value !== this.lcsw_account.merchant_city_code || init) {
        this.lcsw_account.merchant_city = e.label
        this.lcsw_account.merchant_city_code = e.value
        e.value && this.counties_index(e.value)
        if (init) {
          const { merchant_county_code } = this.lcsw_account
          this.change_county({
            value: merchant_county_code
          })
        } else {
          this.lcsw_account.merchant_county = '';
          this.lcsw_account.merchant_county_code = '';
        }
      }
    },
    change_county (e) {
      e = e || {};
      this.lcsw_account.merchant_county = e.label
      this.lcsw_account.merchant_county_code = e.value
    },
    change_net_bank (e) {
      e = e || {};
      this.lcsw_account.merchant_county = e.label
    },
    change_bank (e) {
      e = e || {};
      this.lcsw_account.bank_name = e.label
      this.lcsw_account.bank_no = e.value
    },
    change_company_bank (e) {
      e = e || {};
      this.lcsw_account.company_bank_name = e.label
      this.lcsw_account.company_bank_no = e.value
    },
    change_merchant_business_type (e) {
      e = e || {};
      this.$set(this.lcsw_account, 'merchant_business_type', e.value);
      this.fromKey = new Date().getTime()
    },
    change_business_code (e) {
      e = e || {};
      this.lcsw_account.business_code = e.value
    },
    change_license_type (e) {
      e = e || {};
      this.lcsw_account.license_type = e.value
    },
    async handleSubmit () {
      const res = await this.nextStep()
      const { merchant_business_type, account_type, settlement_type, merchant_name, merchant_alias, merchant_company, merchant_province_code, merchant_city_code, merchant_county_code, merchant_address, merchant_person, merchant_phone, merchant_email, business_code, img_logo, img_indoor, license_no, license_type, img_license, img_open_permits, img_org_code, img_idcard_holding, artif_nm, legalIdnum, img_idcard_a, img_idcard_b, company_account_name, company_account_no, company_bank_name, company_bank_no, account_name, merchant_id_no, account_no, bank_no, img_bankcard_a, img_private_idcard_a, img_private_idcard_b, img_unincorporated, settle_type, settle_amount, legalIdnumExpire } = this.lcsw_account


      const params = {
        merchant_business_type,
        account_type,
        settlement_type,
        merchant_name,
        merchant_alias,
        merchant_company,
        merchant_province_code,
        merchant_city_code,
        merchant_county_code,
        merchant_address,
        merchant_person,
        merchant_phone,
        merchant_email,
        business_code,
        account_name,
        account_no,
        bank_no,
        company_account_name,
        company_account_no,
        company_bank_name,
        company_bank_no,
        // rate_code,
        license_type,
        settle_type,
        settle_amount,
        legalIdnumExpire
      }
      params.img_logo = img_logo
      params.img_indoor = img_indoor

      if (merchant_business_type !== '3') {
        params.img_license = img_license
        params.license_no = license_no
      } else {
        params.img_idcard_holding = img_idcard_holding
      }
      if (account_type === '1' || (account_type !== '1' && settlement_type === '2')) {
        params.artif_nm = artif_nm
        params.legalIdnum = legalIdnum
        params.legalIdnumExpire = legalIdnumExpire
        params.img_idcard_a = img_idcard_a
        params.img_idcard_b = img_idcard_b
      }
      if (account_type === '2') {
        params.merchant_id_no = merchant_id_no
        params.img_bankcard_a = img_bankcard_a
        params.img_private_idcard_a = img_private_idcard_a
        params.img_private_idcard_b = img_private_idcard_b
      }
      if (merchant_business_type === '1' || (merchant_business_type === '2' && account_type === '1')) {
        params.img_open_permits = img_open_permits
        params.img_org_code = img_org_code
      }
      if (account_type === '2' && settlement_type === '2') {
        params.img_unincorporated = img_unincorporated
      }

      console.info(res, this.lcsw_account, params)
      if (res !== 'ok') return
      this.setLoading(true)
      try {
        if (this.lcsw_account.id) {
          params.id = this.lcsw_account.id
          await this.update(params)
        } else {
          await this.create(params)
        }
        this.setLoading(false)
        this.setLocalData();
        this.find_one()
      } catch (e) {
        this.setLoading(false)
      }
    },
    uploadedUrl_img (url, prop) {
      // console.info('upload', prop, url, this.lcsw_account)
      console.log(url)
      this.$set(this.lcsw_account, prop, url)
    },
    nextStep () {
      return new Promise((resolve, reject) => {
        const { merchant_business_type } = this.lcsw_account
        const fields = ['merchant_business_type', 'account_type', 'settlement_type', 'merchant_name', 'merchant_province_code', 'merchant_city_code', 'merchant_county_code', 'bank_no', 'business_code', 'merchant_company']
        if (merchant_business_type === '3') {
          fields.push('img_idcard_holding')
        }
        Promise.all(fields.map(item => {
          const p = new Promise((resolve, reject) => {
            this.$refs.lcsw_account.validateField(item, (error) => {
              resolve(error)
            })
          })
          return p
        })).then((data) => {
          if (data.join(',').length === fields.length - 1) {
            this.saveLocal()
            // this.currentStep = Math.min(this.currentStep + 1, 3);
            resolve('ok')
          } else {
            this.$refs.lcsw_account.$el.scrollIntoView();
            reject(new Error('error'))
          }
        })
      })
    },
    prevStep () {
      this.currentStep = Math.max(1, this.currentStep - 1);
    },
    saveLocal () {
      try {
        sessionStorage.setItem(LS_KEY_LCSW_ACCOUNT, JSON.stringify(this.lcsw_account));
      } catch (e) {
        console.info(e)
      }
    },
    getLocal () {
      const serialized = sessionStorage.getItem(LS_KEY_LCSW_ACCOUNT);
      if (serialized) {
        return JSON.parse(serialized);
      }
      return {};
    },
    clearLocal () {
      sessionStorage.removeItem(LS_KEY_LCSW_ACCOUNT);
    }
  }
}
</script>

<style lang="scss" scoped>
.m-b {
  margin-bottom: 12px;
}
.m-r {
  margin-right: 12px;
}
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.steps {
  flex: 0 0 auto;
}
.form {
  flex: auto;
  overflow: auto;
}
</style>
